import React from 'react'
import {
  formatOrderTrendDisplay,
  getOrderTrendTone,
} from 'src/utils/spartacusMappers'
import styled from 'styled-components/macro'

const TONE_COLOURS = {
  positive: '#389e0d',
  negative: '#cf1322',
  neutral: '#595959',
  muted: '#8c8c8c',
}

function SpartacusOrderTrendCell({ venue }) {
  const label = formatOrderTrendDisplay(venue)
  const tone = getOrderTrendTone(venue?.orderTrendLabel)

  return <TrendText $tone={tone}>{label}</TrendText>
}

const TrendText = styled.span`
  color: ${({ $tone }) => TONE_COLOURS[$tone] || TONE_COLOURS.muted};
  font-weight: ${({ $tone }) => ($tone === 'muted' ? 400 : 600)};
`

export default SpartacusOrderTrendCell
